import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Lightbox.scss';

import Documents from '../Documents/List';
import Button from './Button';
function Lightbox() {


    const ref = useRef(); 
    const [isOpen, setIsOpen] = useState(false);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        window.sdk.event().on('lightboxToggle', (data) => {
            if (data.section == current.section || !data.section) {
                if(data.parent){
                    data = {section: data.parent}
                } else {
                setIsOpen(false);
                setCurrent(false)
                }
            } else {
                setIsOpen(true);
            }
            setCurrent(data)
        })
    }, []);
   

    const handleClose = () => {
        if(current.parent){
            let data = {section: current.parent}
            setCurrent(data)
        } else {
        setIsOpen(false);
        setCurrent(false)
        }
    }


    const section = () => {
        switch (current.section) {
            case 'docs':
                return <Documents />;
            case 'media':
                return
            case 'html':
                return <div dangerouslySetInnerHTML={{ __html: current.content }}></div>
            default:
                return 'Ooops, something go wrong....'
        }
    }
    
    let renderMedia = null;
    if(current.media){
        if(current.media.type.startsWith('image')) {
            renderMedia = <img className="lightbox-content" ref={ref} src={'//' + window.sdk.getApiUrl() + current.media.path} />
        }
        else if(current.media.type.startsWith('video')) {
            renderMedia = <video className="lightbox-content" controls ref={ref} disablePictureInPicture >
                <source src={'//' + window.sdk.getApiUrl() + current.media.path} type={current.media.type} />
            </video>
        }
    }

    return (
        

        <div className={"lightbox" + (isOpen ? ' open' : '') + ((current.section == "media" || current.section == "html") ? ' lightbox-media' : '')}>
            {current.section == "media" ?
                <React.Fragment>
                    {renderMedia}
                    <Button icon="cancel" style="lightbox-close" size="size2" color="shadow" action={() => handleClose()} />
                </React.Fragment>
                :
                <>
                    {current.section === "html" && (
                        <Button icon="cancel" style="lightbox-close" size="size2" color="shadow" action={() => handleClose()} />
                    )}
                    <div className="lightbox-content" ref={ref}>
                        {isOpen && section()}
                    </div>
                </>
            }
        </div>
    )
}

export default Lightbox;